<template>
  <div class="login">
    <div class="login__overlay" @click.self="closeModal">
      <div class="login__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="login__logo">
        <h2 class="login__title">Сброс пароля</h2>
        <p class="login__text">Не волнуйтесь! На указанный E-mail будет отправлено письмо с инструкцией для
          восстановления пароля.</p>
        <form @submit.prevent="resetPassword">
          <div class="login__inputWrapper">
            <input class="login__input" type="email" v-model="email" required @focus="focused.email = true"
              @blur="focused.email = email !== ''" />
            <label :class="{ floating: focused.email || email !== '' }">E-mail</label>
          </div>
          <p v-if="error" class="login__error">{{ error }}</p>

          <button class="login__btn" :disabled="isLoading" :class="{ 'login__btn--loading': isLoading }" type="submit">
            {{ isLoading ? 'Уже сбрасываем…' : 'Сбросить пароль' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      email: '',
      error: null,
      isLoading: false, // Флаг состояния загрузки
      focused: {
        email: false,
      },
    };
  },
  methods: {
    async resetPassword() {
      this.isLoading = true;
      try {
        const response = await axios.post('/api/pis/v1/user/recover_password', {
          email: this.email,
          linkType: 'mm',
        }, {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            'Content-Type': 'application/json',
          },
        });

        
        this.$router.push('/check-email')
      } catch (error) {
        this.error = error.response?.data.message || error.message;
      }
      this.isLoading = false;
    }

  },
};
</script>

<style scoped>
.login__overlay {
  background-image: url("../assets/img/signup-bg.png");
  background-position: center;
  background-size: cover;
}

.login__text {
  color: #6F6F6F;
}
</style>